import { request } from '@/api/request'

export interface QueryEmailListParams {
  /**
   * 人员名称/邮箱地址筛选
   */
  keyword?: string
  page?: number
  pageSize?: number
  [property: string]: any
}

export const queryEmailList = (params: QueryEmailListParams) =>
  request('/portal/common/email_users', {
    method: 'GET',
    params,
  })

export interface AddEmailParams {
  /**
   * 邮箱地址
   */
  email?: string
  /**
   * 人员名称
   */
  name?: string
  /**
   * 备注
   */
  remark?: string
  [property: string]: any
}

export const addEmail = (data: AddEmailParams) =>
  request('/portal/common/email_user', {
    method: 'POST',
    data,
  })

export interface DeleteEmailParams {
  /**
   * 人员ID
   */
  id: string
  [property: string]: any
}

export const deleteEmail = (data: DeleteEmailParams) =>
  request(`/portal/common/email_user/${data.id}`, {
    method: 'DELETE',
  })

export interface UpdateEmailParams {
  /**
   * 邮箱地址
   */
  email?: string
  /**
   * 人员名称
   */
  name?: string
  /**
   * 备注
   */
  remark?: string
  [property: string]: any
}

export const updateEmail = (id: string, data: UpdateEmailParams) =>
  request(`/portal/common/email_user/${id}`, {
    method: 'PUT',
    data,
  })

// 获取邮箱详情
export const getEmailDetail = (id: string) =>
  request(`/portal/common/email_user/${id}`, {
    method: 'GET',
  })
